import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';


const Copyright = ({ className = "" }) => {
  return (
    <div className={`footer ${className}`.trim()}>
      <Typography variant="body2" align="center" style={{ color: "#334155", fontWeight: 500 }}>
        {'Copyright © '}
        <Link color="inherit" href="https://www.cuc.edu.co/" style={{ color: "#1f2937" }}>
          Universidad de la Costa CUC
      </Link>{' '}
        {`${new Date().getFullYear()}.`}
      </Typography>
    </div>
  );
}

export default Copyright;

